import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import useStyles from "@hooks/useStyles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Header from "@components/Main/Shared/Header";
import Footer from "@components/Main/Shared/Footer";

const { BRAND_NAME, SITE_NAME } = process.env;
const { CORP_NAME } = "Liaison, Inc.";

const TermsDamages = () => {
	const classes = useStyles("Terms");

	return (
		<React.Fragment>
			<Header />

			<Box p={"16px 0px"} bgcolor={"#f8f9fa"}>
				<Container maxWidth={"lg"}>
					<Box
						p={{ xs: "24px", sm: "40px 80px 60px" }}
						style={{ boxShadow: "rgba(60, 64, 67, 0.15) 0px 1px 3px 1px" }}
						bgcolor={"#FFF"}
						borderRadius={10}
					>
						<Box lineHeight={1.6} className={classes.body}>
							<h1>Liquidated Damages</h1>
							<p>
								<span>
									Liaison, Inc and its affiliates (collectively,
									&ldquo;our,&rdquo; &ldquo;us&rdquo; or &ldquo;we&rdquo;)
									operate websites, provide products and services through mobile
									and other applications, and develop software that are
									governed, as applicable, by our terms of use (our
									&ldquo;TOU&rdquo;). This liquidated damages policy (this
									&ldquo;Policy&rdquo;) applies to our sites and services and
									are incorporated into our TOU. If there is any conflict
									between this Policy and our TOU, this Policy will control. By
									using our sites and services, you are a &ldquo;user&rdquo; and
									you accept and agree to our TOU and this Policy as a legal
									contract between you and us.
								</span>
							</p>
							<p>
								<span>
									Certain terms used in this Policy have the meanings set forth
									in our TOU. In addition, for purposes of this Policy:
								</span>
							</p>
							<ul>
								<li>
									<span>
										"Item of Content" means each and every instance of content
										of any type posted to, stored on or transmitted via our
										sites and services by any user (or any other third party in
										any manner). For example, each single post to our sites and
										services (including but not limited to any ad, comment, flag
										or message posted to the sites and services), each single
										data file stored on our sites and services (including but
										not limited to any account information, text, code, images,
										video or binary file), and each single communication
										transmitted via our sites and services (including but not
										limited to any email or response to an email) is a single
										&ldquo;Item of Content.&rdquo; Each &ldquo;Item of
										Content&rdquo; shall be considered and treated as an
										individual, discrete &ldquo;Item of Content&rdquo; even if
										it contains the same or substantially similar content as one
										or more other Items of Content.
									</span>
								</li>
								<li>
									<span>
										"Account" means each and every account of any type applied
										for, requested or created by any means.
									</span>
								</li>
								<li>
									<span>
										"Instance of Unauthorized Conduct" or "Instance" means each
										individual time our sites or services are accessed in
										connection with or in facilitation of a violation of the
										TOU.&nbsp; With respect to the Instances of Unauthorized
										Conduct enumerated in paragraph 6 below, each day that our
										sites and services are accessed to facilitate one or more of
										the violations enumerated therein shall constitute one
										Instance of Unauthorized Conduct.
									</span>
								</li>
								<li>
									<span>
										"Attempt" shall be defined pursuant to California law.
									</span>
								</li>
							</ul>
							<p>
								<span>
									TOU violations harm the functionality, integrity, and
									reputation of our sites and services; interfere with and
									detract from users' and customers&rsquo; beneficial use and
									enjoyment of our sites and services; and are detrimental to
									our business.&nbsp; Pursuant to Sections 10 (Damages) and 11
									(Injunctive Relief) of the TOU, you acknowledge and agree that
									we incur actual damages as a result of any TOU violations
									detailed below. You further acknowledge and agree that actual
									damages caused by such violations are extremely difficult,
									impossible or impractical to determine or quantify.
									Consequently, you agree it is fair and reasonable for us to
									obtain injunctive relief to prohibit future violations of the
									TOU and recover liquidated damages for past violations of the
									TOU.&nbsp; You further acknowledge that the amounts set forth
									below reflect reasonable estimates of our actual damages from
									each such violation and that such estimates are reasonably
									related to the actual damages incurred by us by each such
									violation.
								</span>
							</p>
							<p>
								<span>
									For each TOU violation below, you therefore agree to pay
									liquidated damages to us in the amount specified. You further
									acknowledge and agree that the imposition of liquidated
									damages for each such TOU violation is independent and
									distinct, and that the assessment of total liquidated damages
									for multiple TOU violations is cumulative. Any conduct or
									content that is permitted pursuant to a written license
									agreement with us shall not be deemed in violation of the TOU
									as long as the conduct or content is specifically authorized
									pursuant to the terms of the license agreement.
								</span>
							</p>
							<ol>
								<li>
									<span>
										{" "}
										$50 Per Item of Content.&nbsp; You agree to pay $50 per Item
										of Content posted or stored on, or transmitted via our sites
										and services either by you or on your behalf: (a) using any
										automated means to perform any step of any process for
										submitting content (in whole or in part); (b) by any means
										that circumvent any technological measure implemented by us
										to restrict the manner in which content may be submitted on
										our sites and services or to regulate the manner in which
										content (including but not limited to email) may be
										transmitted to other users; or (c) using Accounts that are
										created or used in violation of Section 3(b) (Accounts) of
										the TOU.
									</span>
								</li>
							</ol>
							<p>
								<span>
									Liquidated damages under this Section 1 are in addition to
									liquidated damages that may be applicable pursuant to other
									sections of this Policy and are agreed to be a reasonable
									estimate of our actual damages for such violation described in
									this Section 1 in addition to the liquidated damages incurred
									by us set forth elsewhere in this Policy.
								</span>
							</p>
							<ol>
								<li>
									<span>
										{" "}
										$100 Per Item of Content.&nbsp; You agree to pay $100 per
										Item of Content posted or stored on, or transmitted via our
										sites and services either by you or on your behalf: (a) that
										offers, promotes, advertises or provides links to
										unsolicited products or services (except that the content
										described in section 4(g) of this Policy shall be subject to
										liquidated damages as provided in section 4(g)); (b) that
										violates guidelines for particular categories or services;
										or (c) for purposes of affiliate marketing or in connection
										with any affiliate marketing system, scheme or program in
										any manner and under any circumstance (including but not
										limited to ads, emails and other communications with users
										of the service).
									</span>
								</li>
							</ol>
							<p>
								<span>
									Liquidated damages under this Section 2 are in addition to
									liquidated damages that may be applicable pursuant to other
									sections of this Policy and are agreed to be a reasonable
									estimate of our actual damages for such violation described in
									this Section 2 in addition to the liquidated damages incurred
									by us set forth elsewhere in this Policy.
								</span>
							</p>
							<ol>
								<li>
									<span>
										{" "}
										$100 Per Account/Instance.&nbsp; You agree to pay $100 per
										Account/Instance of Unauthorized Conduct: (a) if you create,
										maintain or use at any time more than one Account to post
										content; (b) if you create one or more Accounts for or on
										behalf of another; (c) if you permit, enable, induce or
										encourage someone else to create one or more Accounts on
										your behalf; (d) if you use other users' Accounts (with or
										without their knowledge or consent) (including but not
										limited to your use of any Account you purchase or otherwise
										do not personally create); (e) for any Account you purchase,
										offer, market, sell, or distribute; (f) for any Account you
										create for another; (g) for any Account you create by any
										automated means; (h) if you use any Accounts created in
										circumvention of any technological restriction or security
										measure in the Account creation process; (i) if you create
										any Accounts in circumvention of any technological
										restriction or security measure in the Account creation
										process; (j) for any product, software, or tool (including
										but not limited to CAPTCHA credits) you acquire, purchase,
										offer, market, sell, or distribute, that facilitates
										circumvention of any technological measure implemented by us
										to restrict the manner in which content may be posted on the
										service or to regulate the manner in which content may be
										transmitted to other users; (k) if you collect users'
										personal information (including but not limited to email
										addresses, IP addresses and telephone numbers), or (l) for
										any activities (including but not limited to posting
										voluminous content) that are inconsistent with use of the
										service in compliance with the TOU or that may impair or
										interfere with the functionality, performance or quality of
										all or any part of the service in any manner.
									</span>
								</li>
							</ol>
							<p>
								<span>
									Liquidated damages under this Section are in addition to
									liquidated damages that may be applicable pursuant to other
									sections of this Policy and are agreed to be a reasonable
									estimate of our actual damages for such violation described in
									this Section in addition to the liquidated damages incurred by
									us set forth elsewhere in this TOU.
								</span>
							</p>
							<ol>
								<li>
									<span>
										{" "}
										$1,000 Per Item of Content.&nbsp; You agree to pay $1,000
										per Item of Content that contains: (a) illegal content; (b)
										content that facilitates the creation, advertising,
										distribution, provision or receipt of illegal goods or
										services; (c) offensive content (including, without
										limitation, defamatory, threatening, hateful or pornographic
										content); (d) content that discloses another's personal,
										confidential or proprietary information; (e) false or
										fraudulent content (including but not limited to false,
										fraudulent or misleading responses to user ads transmitted
										via the service); (f) malicious content (including, without
										limitation, malware or spyware); or (g) content that offers,
										promotes, advertises, provides links to or solicits posting
										or auto-posting products or services, account creation or
										auto-creation products or services, bulk telephone numbers,
										or any other product or service that if utilized with
										respect to the service would violate the TOU or our other
										legal rights.
									</span>
								</li>
							</ol>
							<p>
								<span>
									Liquidated damages under this Section are in addition to
									liquidated damages that may be applicable pursuant to other
									sections of this Policy and are agreed to be a reasonable
									estimate of our actual damages for such violation described in
									this Section in addition to the liquidated damages incurred by
									us set forth elsewhere in this TOU.
								</span>
							</p>
							<ol>
								<li>
									<span>
										{" "}
										$25,000 Per Instance of Unauthorized Conduct.&nbsp;
										Technology can be misused to facilitate harm to our sites
										and services, users, and/or our business on a massive
										scale.&nbsp; Accordingly, you agree to pay $25,000 per
										Instance of Unauthorized Conduct that includes: (a) copying,
										aggregating, displaying, distributing or creating derivative
										use of our sites or services or any content posted on our
										sites and services (including, but not limited to, by means
										of spiders, robots, crawlers, scrapers, framing, iframes, or
										RSS feeds); (b) access to or use of our sites or services to
										design, develop, test, update, operate, modify, maintain,
										support, market, advertise, distribute, or otherwise make
										available any program, application or service (including,
										without limitation, any device, technology, product,
										computer program, mobile device application, website, and
										mechanical or personal service) that enables or provides
										access to, use of, operation of, or interoperation with our
										sites and services (including, without limitation, to access
										content, post content, respond to content, transmit content,
										create accounts, use accounts, circumvent security measures,
										or flag content); or (c) decompiling, disassembling or
										reverse engineering all or any part of our sites or services
										in order to identify, acquire, copy, or emulate any source
										code or object code.
									</span>
								</li>
							</ol>
							<p>
								<span>
									Liquidated damages under this Section are in addition to
									liquidated damages that may be applicable pursuant to other
									sections of this TOU and are agreed to be a reasonable
									estimate of our actual damages for such violation described in
									this Section in addition to the liquidated damages incurred by
									us set forth elsewhere in this TOU.
								</span>
							</p>
							<p>
								<span>Last updated: August 10, 2023</span>
							</p>
						</Box>
					</Box>
				</Container>
			</Box>

			<Footer />
		</React.Fragment>
	);
};

export default TermsDamages;
export const loader = (route) =>
	loadable(() => import("./TermsDamages.component"), { ssr: !!route.ssr });
